import { useState, useRef, useEffect } from "react";
import whatsAppIcon from "../../assets/images/socialIcons/whatsapp.webp";
import chCare from "../../assets/images/companyLogos/chcare.webp";
import chConnect from "../../assets/images/companyLogos/chconnect.webp";
import ceylonHospital from "../../assets/images/companyLogos/Ceylon Hospital.webp";
import nurseIcon from "../../assets/images/quickButton/caller2.webp";

interface ActionItem {
  name: string;
  icon: string;
  number: string;
  action: () => void;
}

const HoverActionButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const formatPhoneNumber = (number: string): string => {
    const cleaned = number.replace(/\D/g, "");

    if (cleaned.length === 10 && cleaned.startsWith("0")) {
      return `+94 ${cleaned.substring(1, 3)} ${cleaned.substring(
        3,
        6
      )} ${cleaned.substring(6)}`;
    }

    if (cleaned.length === 12 && cleaned.startsWith("94")) {
      return `+${cleaned.substring(0, 2)} ${cleaned.substring(
        2,
        4
      )} ${cleaned.substring(4, 7)} ${cleaned.substring(7)}`;
    }

    return number;
  };

  const actions: ActionItem[] = [
    {
      name: "WhatsApp",
      icon: whatsAppIcon,
      number: "Click Icon",
      action: () => window.open(`https://wa.me/94705509898`, "_blank"),
    },
    {
      name: "CH Care",
      icon: chCare,
      number: "0710622337",
      action: () => (window.location.href = `tel:0710622337`),
    },
    {
      name: "CH Connect",
      icon: chConnect,
      number: "0710622352",
      action: () => (window.location.href = `tel:0710622352`),
    },
    {
      name: "Ceylon Hospital",
      icon: ceylonHospital,
      number: "0712509898",
      action: () => (window.location.href = `tel:0712509898`),
    },
  ];

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false);
    }, 300);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className="fixed end-6 bottom-10 Blinker-Regular z-20"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      aria-label="Quick action buttons"
    >
      <div className="relative">
        {actions.map((action, index) => (
          <ActionButton
            key={`${action.name}-${index}`}
            action={action}
            index={index}
            isHovered={isHovered}
            formatPhoneNumber={formatPhoneNumber}
          />
        ))}
      </div>

      <MainButton isHovered={isHovered} />
    </div>
  );
};

interface ActionButtonProps {
  action: ActionItem;
  index: number;
  isHovered: boolean;
  formatPhoneNumber: (num: string) => string;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  action,
  index,
  isHovered,
  formatPhoneNumber,
}) => (
  <div
    className={`absolute right-0 transition-all duration-700  ease-[cubic-bezier(0.68,-0.55,0.265,1.55)] ${
      isHovered
        ? "opacity-100 translate-y-0 pointer-events-auto"
        : "opacity-0 translate-y-10 pointer-events-none"
    }`}
    style={{
      bottom: `${(index + 1) * 60}px`,
      transitionDelay: isHovered ? `${index * 100}ms` : "0ms",
    }}
  >
    <div className="relative group -mb-10">
      <button
        type="button"
        onClick={action.action}
        aria-label={`${action.name} - ${
          action.number === "Click Icon"
            ? "Open chat"
            : formatPhoneNumber(action.number)
        }`}
        className="flex justify-center items-center text-gray-600 hover:text-white hover:bg-blue-600 rounded-full border-2 border-gray-200 hover:border-blue-600 shadow-sm transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-opacity-50"
      >
        {/* <img
          src={action.icon}
          alt="" // Decorative image
          loading="lazy"
          className="w-14 h-13 rounded-full object-cover"
          aria-hidden="true"
        /> */}

        <img
          src={action.icon}
          alt=""
          loading="lazy"
          width={56}
          height={52}
          className="rounded-full object-cover"
          aria-hidden="true"
        />
      </button>
      <div
        className="absolute right-14 top-1/2 -translate-y-1/2 z-10 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 px-3 py-2 text-sm font-medium text-white bg-gray-800 rounded whitespace-nowrap shadow-lg min-w-[180px]"
        role="tooltip"
      >
        <div className="font-bold text-center">{action.name}</div>
        <div className="text-blue-300 text-center mt-1">
          {formatPhoneNumber(action.number)}
        </div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-2 h-2 bg-gray-800 rotate-45"></div>
      </div>
    </div>
  </div>
);

interface MainButtonProps {
  isHovered: boolean;
}

const MainButton: React.FC<MainButtonProps> = ({ isHovered }) => (
  <button
    type="button"
    className="flex z-99 items-center justify-center rounded-full w-14 h-14 shadow-lg transition-all duration-500 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50"
    aria-expanded={isHovered}
    aria-label="Quick actions menu"
  >
    <img
      src={nurseIcon}
      alt="Quick actions"
      className="rounded-full h-14 w-14 transition-transform duration-500 ease-in-out border-orange-900 border-2 shadow-lg"
    />
  </button>
);

export default HoverActionButton;

// import { useState, useRef, useEffect } from "react";
// import whatsAppIcon from "../../assets/images/socialIcons/whatsapp.png";
// import chCare from "../../assets/images/companyLogos/chcare.jpeg";
// import chConnect from "../../assets/images/companyLogos/chconnect.jpeg";
// import ceylonHospital from "../../assets/images/companyLogos/Ceylon Hospital.jpg";
// import nurseIcon from "../../assets/images/quickButton/caller2.jpg";

// const HoverActionButton = () => {
//   const [isHovered, setIsHovered] = useState(false);
//   const timeoutRef = useRef<NodeJS.Timeout | null>(null);

//   const formatPhoneNumber = (number: string) => {
//     const cleaned = number.replace(/\D/g, "");

//     if (cleaned.length === 10 && cleaned.startsWith("0")) {
//       return `+94 ${cleaned.substring(1, 3)} ${cleaned.substring(
//         3,
//         6
//       )} ${cleaned.substring(6)}`;
//     }

//     if (cleaned.length === 12 && cleaned.startsWith("94")) {
//       return `+${cleaned.substring(0, 2)} ${cleaned.substring(
//         2,
//         4
//       )} ${cleaned.substring(4, 7)} ${cleaned.substring(7)}`;
//     }

//     return number;
//   };

//   const actions = [
//     {
//       name: "WhatsApp",
//       icon: whatsAppIcon,
//       number: "Click Icon",
//       action: () => window.open(`https://wa.me/94705509898`, "_blank"),
//     },
//     {
//       name: "CH Care",
//       icon: chCare,
//       number: "0710622337",
//       action: () => (window.location.href = `tel:0710622337`),
//     },
//     {
//       name: "CH Connect",
//       icon: chConnect,
//       number: "0710622352",
//       action: () => (window.location.href = `tel:0710622352`),
//     },
//     {
//       name: "Ceylon Hospital",
//       icon: ceylonHospital,
//       number: "0712509898",
//       action: () => (window.location.href = `tel:0712509898`),
//     },
//   ];

//   const handleMouseEnter = () => {
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//     setIsHovered(true);
//   };

//   const handleMouseLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       setIsHovered(false);
//     }, 300);
//   };

//   useEffect(() => {
//     return () => {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div
//       className="fixed end-6 bottom-10 Blinker-Regular z-20"
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//     >
//       {/* Action Buttons - Appear on hover with staggered animation */}
//       <div className="relative">
//         {actions.map((action, index) => (
//           <div
//             key={action.name}
//             className={`absolute right-0 transition-all duration-700 ease-[cubic-bezier(0.68,-0.55,0.265,1.55)] ${
//               isHovered
//                 ? `opacity-100 translate-y-0 pointer-events-auto`
//                 : `opacity-0 translate-y-10 pointer-events-none`
//             }`}
//             style={{
//               bottom: `${(index + 1) * 60}px`,
//               transitionDelay: isHovered ? `${index * 100}ms` : "0ms",
//             }}
//           >
//             <div className="relative group -mb-10">
//               <button
//                 type="button"
//                 onClick={action.action}
//                 className="flex justify-center items-center text-gray-600 hover:text-white hover:bg-blue-600 rounded-full border-2 border-gray-200 hover:border-blue-600 shadow-sm transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-opacity-50"
//               >
//                 <img
//                   src={action.icon}
//                   alt=''
//                   loading="lazy"
//                   className="w-12 h-12 rounded-full object-cover"
//                 />
//                 <span className="sr-only">{action.name}</span>
//               </button>
//               <div className="absolute right-14 top-1/2 -translate-y-1/2 z-10 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 px-3 py-2 text-sm font-medium text-white bg-gray-800 rounded whitespace-nowrap shadow-lg min-w-[180px]">
//                 <div className="font-bold text-center">{action.name}</div>
//                 <div className="text-blue-300 text-center mt-1">
//                   {formatPhoneNumber(action.number)}
//                 </div>
//                 <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-2 h-2 bg-gray-800 rotate-45"></div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Main FAB Button */}
//       <button
//         type="button"
//         className="flex items-center justify-center  rounded-full lg:w-16 lg:h-16 w-14 h-15 shadow-lg transition-all duration-500 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50"
//         aria-expanded={isHovered}
//       >
//         <img
//           src={nurseIcon}
//           loading="lazy"
//           alt="nurse"
//           className="rounded-full transition-transform duration-500 ease-in-out border-orange-900  border-2 shadow-lg"
//         />
//         <span className="sr-only">Quick actions</span>
//       </button>
//     </div>
//   );
// };

// export default HoverActionButton;

// import React from "react";

// import whatsAppIcon from "../../assets/images/socialIcons/whatsapp.png";

// const WhatsAppQuicButton: React.FC = () => {
//   const phoneNumber = "94705509898";
//   const message = "";

//   return (
//     <div className="fixed  lg:bottom-20 bottom-16 lg:right-10 right-6 z-50 hover:opacity-75">
//       <a
//         href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
//           message
//         )}`}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="flex items-center justify-center w-16  h-10 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl"
//         aria-label="Chat on WhatsApp"
//       >
//         <img src={whatsAppIcon} alt="WhatsApp" />
//       </a>
//     </div>
//   );
// };

// export default WhatsAppQuicButton;
